<template>
  <div>
    <template v-if="_.trim(ftieId) === ''">
      {{ ftieId }}
    </template>
    <template v-else>
      <a class="link" target="_blank" :href="safeUrl(`${ $root.frontEndUrl }/dashboard/${ ftieId }`)">{{ ftieId }}</a>
    </template>
  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'gtc-ftie',
    props: ['ftieId']
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcFTIE.vue